import { useContext } from "react";
import { MyDriversContext } from "./context";
import { MyDriversContextProps } from "./models";

export const useMyDriversContext = (): MyDriversContextProps => {
  const context = useContext(MyDriversContext);

  if (!context) {
    throw new Error(
      "useMyDriversContext precisa estar dentro de um MyDriversProvider"
    );
  }

  return context;
};
